export default {
  button_add: 'Ajouter champ',
  button_object_properties: 'Ajouter/Supprimer des champs',
  error_type: 'La valeur doit être un nombre',
};
